import dataModel from '../../models/DataModel.js';
import projectsService from '../../services/projectsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';
import { RecordStates } from '../../constants/ReduxConstants';

export default class LocationProjectsCollection extends AOCollection {
  constructor(name, searchString, locationId, userId, companyId, filter, recordDescriptor) {
    super({
      name: name,
      collectionType: ReduxConstants.PROJECT,
      searchString, 
      userId,
      companyId, 
      subKey: locationId,
      filter,
      recordDescriptor,
    });
    this.locationId = locationId;
  }

  static build(name, searchString, locationId, userId, companyId, filter, recordDescriptor) {
    let collection = new LocationProjectsCollection(name, searchString, locationId, userId, companyId, filter, recordDescriptor);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    else {
      collection._filter = collectionData._filter;
    }
    return collection;
  }

  handleOffLineFetch(options) {

    let denormalizedCollection = this.getDenormalizedCollection(options);
    return new Promise((resolve) => {
      let reg = null;
      if (this._searchString) {
        const words = this._searchString.toLowerCase().split(/\s/);
        let exp = '^(?=.*\\b' + words[0] + '\\S*)';
        if (words.length > 0) {
          words.forEach((word, index) => {
            if (index > 0) {
              exp += '(?=.*\\b' + word + '\\S*)';
            }
          });
        }
        exp += '.+';
        reg = new RegExp(exp);
      }
      denormalizedCollection.ids = [];
      const foundProjects = denormalizedCollection.projects.filter(async project => {
        if (reg) {
          if (reg.test(project.name.toLowerCase())) {
            denormalizedCollection.ids.push(project.id);
            return true;
          }
        }
        else {
          return true;
        }
        return false;
      });

      denormalizedCollection.projects = foundProjects;
      resolve(denormalizedCollection);
    });
  }

  get projects() {
    let collection = this.findCollection(this.getKey());
    return collection.items;
  }

  async fetchCurrent(shouldPaginate = true, options = {}, prefetchCallback) {

    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = projectsService.getProjectsForLocation.bind(this, this.locationId, this._searchString, this._filter, options);
      
        let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }
    
        newCollection.totalProjects = newCollection.meta ? newCollection.meta.total_projects : 0;
        return resolve(newCollection);
      });
    }
  }

  setFilter(filter = {}, ignoreIdReset) {
    if (this.isEmpty(filter) && this.isEmpty(this._filter)) {
      return;
    }
    if (filter != this._filter || !filter) {
      this._filter = filter ? filter : {};
      this._recordState = RecordStates.NEEDS_SYNC;
      this.ids = ignoreIdReset ? this.ids : [];
      dataModel.collectionsDAO.setCollection(this.getKey(), this.getData(), this.getCollectionType());
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/LocationProjectsCollection.js